import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import CampoNroTelefono from "./CampoNroTelefono"
import ConfirmarOperacion from "../../pages/Alerta/ConfirmarOperacion";
import ConfirmarOperacionSimple from "../../pages/Alerta/ConfirmarOperacionSimple";
import DatosSocio from "../../generico/DatosSocio";
import PopupAgregarCuentaBasa from "./PopupCambioNumero";
import Select from "react-select";
import { trackPromise } from 'react-promise-tracker';
import { phoneNumberValido, phoneFormatter, formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import $ from "jquery";
import Popup from "react-popup";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import SeleccionTarjeta from "../../pages/Alerta/SeleccionTarjeta";
import authService from "../../../services/login/auth.service";
import DataTable from "react-data-table-component";
import HabilitarCuentasService from "../../../services/autogestion/HabilitarCuentasService";
import Switch from "react-switch";
import InputMask from "react-input-mask";
import ConfigService from "../../../services/configuracion/ConfigService";
import history from "../login/history";
import MensajeUsuario from "../../generico/MensajeUsuario";
import Prestamos from "../resumenGeneral/Prestamo";
import AvisoPrestamo from "../../generico/Prestamo/AvisoPrestamo";
import SolicitudesPrestamo from "../resumenGeneral/SolicitudesPrestamos";
import SeleccionTarjetaSwitch from "../../pages/Alerta/SeleccionTarjetaSwitch";
import { Route, withRouter, useHistory } from 'react-router-dom';
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faPhone, faBell, faCreditCard, faSearch } from "@fortawesome/free-solid-svg-icons";
const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

const AuxNavItem = ({ children, name, onClick, href }) => {

  const handleClick = () => {
    // onClick();
  }

  let prevPath = ConfigService.getPreviousPathByName(name);

  let isFirst = prevPath === null ? true : false;


  /**
   * @description contiene las clases a asignar, segun el path habilitado
   */
  let className = isFirst
    ? "nav-link active"
    : prevPath === null
      ? "nav-link active"
      : "nav-link"


  return (
    ConfigService.getPathByName(name) !== null
      ?
      <li className="nav-item" >
        <a className={className}
          href={href}
          data-toggle="tab"
          id={name}
          onClick={() => handleClick()}
        >
          {children}
        </a>
      </li>
      : null
  )
}


const TabPane = ({ children, id, name }) => {

  let prevPath = ConfigService.getPreviousPathByName(name);

  let isFirst = prevPath === null ? true : false;

  /**
   * @description contiene las clases a asignar, segun el path habilitado
   */
  let className = isFirst
    ? "tab-pane table-responsive active"
    : prevPath === null
      ? "tab-pane table-responsive active"
      : "tab-pane table-responsive"

  return (
    ConfigService.getPathByName(name) !== null
      ?
      <div className={className}
        id={id}
      >
        {children}
      </div>
      : null
  )
}


export default class SuscripcionAlerta extends Component {

  constructor(props) {
    super(props);
    this.refTC = React.createRef();
    this.refAporte = React.createRef();

    this.state = {
      itemsConfirm: [],
      telefono: undefined,
      telefonoNuevo: undefined,
      phoneFormat: undefined,
      phoneNewFormat: undefined,
      alertasDisp: [],
      suscripciones: [],
      alerta: undefined,
      alertaSelected: undefined,
      moneda: undefined,
      costo: undefined,
      habAlert: false,
      lista: [],
      listaAlertas: [],
      listaAlertasTarjetas: [],
      listaAlertasOriginal: [],
      showMe: false,
      inputDisabled: true,
      telefonoActual: undefined,
      showButtonChange: true,
      paso: "Paso 2 -",
      accionNumero: false,
      estadoAlerta: undefined,
      tipoAlerta: undefined,
      numeroAlerta: undefined,
      valor: false,
      alertaSelectedId: undefined,
      mostrarConfirmar: true,
      titleMensaje: undefined,
      listaTC: undefined,
      numeroTarjetaAdd: undefined,
      numeroTarjetaPrincipal: undefined,

      simulateClick(e) {
        e.click()
      }


    };

    this.obtenerListadoAlertasTarjetas = this.obtenerListadoAlertasTarjetas.bind(this);


    this.obtenerListadoAlertas = this.obtenerListadoAlertas.bind(
      this
    );
  }



  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  componentDidMount() {
    this.setState({ alertasDisp: this.getAlertasDisponibles() });
    this.setState({ listaTC: this.obtenerTarjetas() });

    this.setState({ listaAlertas: this.obtenerListadoAlertas() });
  }

  getAlertasDisponibles() {
    var alertas = [];

    trackPromise(
      SolicitudesService.getAlertasDisponibles()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.resultado.length; i++) {
              alertas.push({
                value: jsonData.resultado[i].numero,
                moneda: jsonData.resultado[i].moneda,
                costo: formatoSeparadorMilesValue(jsonData.resultado[i].costo),
                identificador: jsonData.resultado[i].identificador,
                label:
                  jsonData.resultado[i].descripcion + " -  COSTO " + formatoSeparadorMilesValue(jsonData.resultado[i].costo) + " ." + jsonData.resultado[i].moneda,
              });
            }

          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            return;
          }
        }).catch(function (error) {
          authService.logout()

        }));


    return alertas;
  }

  loadData() {
    var valores = this.state.alerta;

    var resultado = valores.split(" ");
    var label = this.state.alertaSelected.label;
    var res_label = label.split("-");
    var alerta = resultado[resultado.length - 1];
    var _itemsConfirm = [
      { concepto: "Número de Alerta", valor: resultado[resultado.length - 1] },
      { concepto: "Denominación", valor: res_label[0] },
      { concepto: "Moneda", valor: this.state.moneda },
      { concepto: "Costo", valor: this.state.costo },
      { concepto: "Teléfono Receptor", valor: this.state.phoneFormat },
    ];

    var respuesta = [];
    if (alerta === "5") {


      for (var i = 0; i < this.state.lista.length; i++) {
        if (this.state.lista[i].suscribir === true) {
          var opcion = "N"
          if (this.state.lista[i].adicional === true)
            opcion = "S"
          respuesta.push({
            numeroTarjeta: this.state.lista[i].nroTarjeta,
            opcion: opcion,
          });
        }
      }
    }
    this.setState({ itemsConfirm: _itemsConfirm, suscripciones: respuesta });
    this.modalCtrlConfirm.click();
  }
  loadDataUpdateNum() {

    var _itemsConfirm = [

      { concepto: "Teléfono Receptor", valor: this.state.phoneFormat },
    ];



    this.setState({ itemsConfirm: _itemsConfirm });
    this.modalCtrlConfirm.click();
  }

  obtenerColumas() {
    return [
      {
        name: "Nombre de Alarma",
        selector: row => row.nombre,
        grow: 3,
      },
      {
        name: "Costo",
        selector: row => row.costo,
        right: true,
      }
    ];
  }

  obtenerFilas() {
    return [{
      id: 1,
      nombre: "RECHAZO DEPOSITO EN CTA. AHORRO CHEQUE",
      costo: "0.00 GS."
    },
    {
      id: 2,
      nombre: "AVISO PROX.VTO.AHORRO PLAZO FIJO",
      costo: "0.00 GS."
    }];
  }
  getColumnTarjeta() {
    return [
      {
        name: "Marca",
        selector: row => row.marca,
      },
      {
        name: "Tarjeta",
        selector: row => row.nroTarjeta,
      },
      {
        name: "Estado Tarjeta Principal",
        cell: (row) => (
          <Switch id={row.nroTarjeta}
            onChange={this.handleChangeSwitchTarjetas}
            checked={row.estadoAlerta == 'A'}
            vValue='Principal'
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#EAAC24" />
        ),
        //  width: "100px",
      },
      {
        name: "Estado Tarjeta Adicional",
        cell: (row) => (
          <Switch id={row.nroTarjeta}
            onChange={this.handleChangeSwitchTarjetasAdd}
            checked={row.adicional != 'N'}
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#EAAC24" />
        ),
        // width: "100px",
      }
    ]
  }



  phoneSelectorValue = (dataFromChild) => {

    var valor = this.formatearPhone(dataFromChild)
    var res = valor.split("_")

    if (res.length === 1)
      this.setState({
        phoneFormat: dataFromChild,
        telefono: valor,
        habAlert: true,
        showButtonChange: false
      });
    else
      this.setState({
        phoneFormat: dataFromChild,
        telefono: valor,
        habAlert: false
      });
  };

  phoneNewSelectorValue = (dataFromChild) => {

    var valor = this.formatearPhone(dataFromChild)
    var res = valor.split("_")

    if (res.length === 1)
      this.setState({
        phoneNewFormat: dataFromChild,
        telefonoNuevo: valor,
        habAlert: true,
        showButtonChange: false
      });
    else
      this.setState({
        phoneNewFormat: dataFromChild,
        telefonoNuevo: valor,
        habAlert: false
      });
  };

  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");

    return valor;

  }

  loadDataConfirm() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.loadData();
      }
    });
    $("#idAlertaForm").submit(function (e) {

      e.preventDefault();
      $.validator.addMethod(
        "prefijos",
        function (value, element) {

          return phoneNumberValido(element.value);

        }
      );
      $.validator.addMethod(
        "prefijoMin",
        function (value, element) {
          var tam = phoneFormatter(element.value)
          if (tam.length < 10)
            return false
          return true;

        }
      );
      var data = {};
      var dataArray = $('#idAlertaForm').serializeArray();

      for (var i = 0; i < dataArray.length; i++) {

        data[dataArray[i].name] = dataArray[i].value;
        if (dataArray[i].name == "tipo" && dataArray[i].value === "") {

          e.target[0].classList.add("error")
          e.target[0].classList.add("is-invalid")

          e.target[0].name = "alerta"
          e.target[0].classList.add("is-invalid")
          var prueba = document.getElementById('prueba')
          prueba.classList.add("prueba")

        }
        if (dataArray[i].name == "tipo" && dataArray[i].value !== "") {
          e.target[0].name = ""
          var prueba = document.getElementById('prueba')
          prueba.classList.remove("prueba")
        }

      }

    }).validate(
      {
        ignore: "input[type='text']:hidden",
        rules: {
          alerta: {
            required: true,

          },
          tipo: {
            required: true,

          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },

          },



        },
        messages: {
          alerta: {
            required: "Este campo es requerido",

          },
          tipo: {
            required: "Este campo es requerido",

          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          },
          telefonoNuevo: {

            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          }


        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);

        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }
  loadDataConfirmAlert() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.loadData();
      }
    });
    $("#idAlertaForm").submit(function (e) {

      var data = {};
      var dataArray = $('#idAlertaForm').serializeArray();

      for (var i = 0; i < dataArray.length; i++) {

        data[dataArray[i].name] = dataArray[i].value;
        if (dataArray[i].name == "tipo" && dataArray[i].value === "") {

          e.target[0].classList.add("error")
          e.target[0].classList.add("is-invalid")

          e.target[0].name = "alerta"
          e.target[0].classList.add("is-invalid")
          var prueba = document.getElementById('prueba')
          prueba.classList.add("prueba")

        }
        if (dataArray[i].name == "tipo" && dataArray[i].value !== "") {
          e.target[0].name = ""
          var prueba = document.getElementById('prueba')
          prueba.classList.remove("prueba")
        }

      }

    }).validate(
      {
        ignore: "input[type='text']:hidden",
        rules: {
          alerta: {
            required: true,

          },
          tipo: {
            required: true,

          }

        },
        messages: {
          alerta: {
            required: "Este campo es requerido",

          },
          tipo: {
            required: "Este campo es requerido",

          }


        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);

        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }
  loadDataConfirmActualizarNumero() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.loadDataUpdateNum();
      }
    });
    $("#idAlertaForm").submit(function (e) {

      e.preventDefault();
      $.validator.addMethod(
        "prefijos",
        function (value, element) {

          return phoneNumberValido(element.value);

        }
      );
      $.validator.addMethod(
        "prefijoMin",
        function (value, element) {
          var tam = phoneFormatter(element.value)
          if (tam.length < 10)
            return false
          return true;

        }
      );


    }).validate(
      {
        ignore: "input[type='text']:hidden",
        rules: {
          alerta: {
            required: true,

          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },

          },



        },
        messages: {
          alerta: {
            required: "Este campo es requerido",

          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          },


        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);

        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }


  limpiarTodo = () => {
    document.getElementById('telefono').value = "";
    this.inicializarEstados();


  }

  inicializarEstados = () => {
    this.setState({
      itemsConfirm: [],
      telefono: undefined,
      telefonoNuevo: undefined,
      phoneFormat: undefined,
      suscripciones: [],
      alerta: undefined,
      alertaSelected: undefined,
      moneda: undefined,
      costo: undefined,
      habAlert: false,
      alertaSelectedId: undefined

    }
    );


  }

  confirmarBtn = () => {
    var valores = this.state.alerta;
    var resultado = valores.split(" ");

    trackPromise(
      SolicitudesService.confirmarAlertas(resultado[resultado.length - 1], this.state.telefonoActual, this.state.costo, this.state.suscripciones)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            mensajeExito("La Suscripción a Alertas se Realizó Correctamente")
            this.limpiarTodo()
          }
          else {
            Popup.create({
              title: "Suscripción a Alertas",
              content: jsonData.mensajeRetorno,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {
                    Popup.close();
                  }
                }]
              }
            });
          }
        }

        ));

  }
  loadDataConfirmAccion = () => {

    this.loadDataConfirm()

  }

  confirmarBtnNum = () => {
    trackPromise(
      SolicitudesService.confirmarCambioNumero(this.state.telefono)

        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            mensajeExito("El cambio de Número se Realizó Correctamente");
            this.setState({
              telefonoActual: this.state.telefono,
             
            })
            sessionStorage.setItem("NumeroActual", this.state.telefono);
            $(".collapse").removeClass("show");
            this.limpiarTodo();
          }
          else {
            Popup.create({
              title: "Suscripción a Alertas",
              content: jsonData.mensajeRetorno,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {
                    Popup.close();
                  }
                }]
              }
            });
          }
        }

        ));

  }
  confirmarBtnTarjetas = () => {
    trackPromise(
      SolicitudesService.SuscripcionTarjeta(this.state.numeroTarjetaPrincipal)

        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            mensajeExito("La operación se realizó correctamente");
            this.setState({
              nroTarjeta: this.state.numeroTarjetaPrincipal
            })
            $(".collapse").removeClass("show");
            this.setState({ listaTC: this.obtenerTarjetas() });
            this.limpiarTodo();
          }
          else {
            Popup.create({
              title: "Suscripción a Alertas",
              content: jsonData.mensajeRetorno,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {
                    Popup.close();
                  }
                }]
              }
            });
          }
        }

        ));

  }


  handleChangeSelector = (selectedOption) => {



    this.limpiarTabs();
    if (selectedOption == null) {
      this.setState({
        alerta: undefined,
        alertaSelected: undefined,
        costo: undefined,
        moneda: undefined,
        alertaSelectedId: undefined,
        listaAlertas: this.state.listaAlertasOriginal
      });
      $(".botonBuscar").addClass("btn-cu-secundary");
      $(".botonBuscar").removeClass("btn-cu-primary");
    }
    else {
      this.setState({
        alerta: selectedOption.value,
        alertaSelected: selectedOption,
        costo: selectedOption.costo,
        moneda: selectedOption.moneda,
        alertaSelectedId: selectedOption.identificador
      });
      $(".botonBuscar").removeClass("btn-cu-secundary");
      $(".botonBuscar").addClass("btn-cu-primary");

      if (selectedOption.numero == "5") {
        $("#prestamosActivos").removeClass(" active");
        $("#prestamosSolicitados").addClass(" active");
        $("#resumenPrestamosActivos").removeClass(" active");
        $("#resumenPrestamosSolicitudes").addClass(" active");
      }
    }

  };
  limpiarTabs = () => {
    $("#prestamosActivos").addClass(" active");
    $("#prestamosSolicitados").removeClass(" active");
    $("#resumenPrestamosActivos").addClass(" active");
    $("#resumenPrestamosSolicitudes").removeClass(" active");
  }

  rptSuscribir = (valor, marca) => {
    var respuesta = [];
    respuesta.push({
      nroTarjeta: valor,
      suscribir: marca,
      adicional: false

    });
    for (var i = 0; i < this.state.lista.length; i++) {
      if (this.state.lista[i].nroTarjeta !== valor) {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: false
        });
      }
    }

    this.setState({ lista: respuesta, suscribiendo: valor }, this.enableNext(marca));

  };
  enableNext(marca) {
    this.refTC.current.checkGrilla(marca);
  }


  rptAdicional = (valor, marca) => {

    var respuesta = [];

    for (var i = 0; i < this.state.lista.length; i++) {
      if (this.state.lista[i].nroTarjeta === valor) {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: marca

        });
      }
      else {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: this.state.lista[i].adicional

        });
      }
    }
    //console.log(respuesta)
    this.setState({ lista: respuesta }, this.enableNextAdicional(marca));

  };
  enableNextAdicional(marca) {
    this.refTC.current.checkGrillaAdi(marca);
  }
  obtenerColumasAlert() {
    return [

      {
        name: "Descripción",
        selector: row => row.descripcion,
        width: ""
      },
      {
        name: "Costo",
        selector: row => row.costo,
        width: ""
      },
      {
        name: "Estado",
        cell: (row) => (
          <Switch id={row.identificador}
            onChange={this.handleChangeSwitch}
            checked={row.estadoAlerta == 'A'}
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#EAAC24"
            offColor="#c4c4c4" />
        ),
        width: "100px",
      }
    ];
  }

  getInitialState = () => ({
    listaAlertas: []
  });



  obtenerListaAlert() {
    const { listaAlertas } = this.state;
    // const { listaCuentas } =[{"cuenta":"122","descripcion":"122","saldo":"122"}];

    return listaAlertas;
  }
  obtenerListadoAlertas = () => {
    sessionStorage.setItem("mostrarNumero", false);
    this.state.showMe = false;
    trackPromise(
      SolicitudesService.obtenerListadoAlertas().then((response) => {
        var respuesta = [];
        var respuestaFiltro = [];

        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        if (jsonData.resultado.length > 0) {

          if (jsonData.resultado[0].telefono) {
            this.state.showMe = true;
            sessionStorage.setItem("mostrarNumero", true);
            sessionStorage.setItem("NumeroActual", jsonData.resultado[0].telefono);
            this.setState({
              telefonoActual: jsonData.resultado[0].telefono,


            })
           
          }
          this.setState({

            habAlert: true,
            accionNumero: true,
            paso: undefined

          })
         
          this.state.inputDisabled = true;


        }
        if (jsonData.codigoRetorno === "0") {
          for (var i = 0; i < jsonData.resultado.length; i++) {
            respuesta.push({
              descripcion: jsonData.resultado[i].descripcion,
              tipo: jsonData.resultado[i].tipo,
              costo: jsonData.resultado[i].costo,
              nroReceptor: jsonData.resultado[i].telefono,
              numero: jsonData.resultado[i].numero,
              identificador: jsonData.resultado[i].identificador,
              estadoAlerta: jsonData.resultado[i].estado,
              identificador: jsonData.resultado[i].identificador,
              label: jsonData.resultado[i].descripcion
            });
          }
          for (var i = 0; i < jsonData.resultado.length; i++) {
            respuestaFiltro.push({
              descripcion: jsonData.resultado[i].descripcion,

            });
          }

        }

        this.setState({ listaAlertas: respuesta });
        this.setState({ listaAlertasOriginal: respuesta });
        this.setState({ listaAlertasFiltro: respuestaFiltro });
      })
    ).catch(function (error) {
      console.log(error);
    });
  };
  //obtener listado de alertas de tarjetas suscriptas
  obtenerListadoAlertasTarjetas = () => {

    trackPromise(
      SolicitudesService.obtenerListadoAlertasTarjetas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);

        if (jsonData.codigoRetorno === "0") {

          for (var i = 0; i < jsonData.resultado.length; i++) {
            let vDescripcion = this.state.listaTC.find(valor => valor.nroTarjeta === jsonData.resultado[i].numeroCuenta);
            respuesta.push({
              nroTarjeta: jsonData.resultado[i].numeroCuenta,
              adicional: jsonData.resultado[i].adicional,
              estadoAlerta: "A",
              marca: vDescripcion ? vDescripcion.marca : null

            });
          }

        }
        this.setState({ listaAlertasTarjetas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  /**
 * HABILITAR / INHABILITAR ALERTAS
 */

  handleChangeSwitch = (checked, event, id) => {
    for (var i = 0; i < this.state.listaAlertas.length; i++) {
      if (this.state.listaAlertas[i].identificador === id) {
        if (checked === true) {
          this.setState({
            msg_up: "¿Desea activar la notificación?", check: true, idSelect: id,
            estadoAlerta: "A",
            tipoAlerta: this.state.listaAlertas[i].tipo,
            numeroAlerta: this.state.listaAlertas[i].numero,
            mostrarConfirmar: true
          });
        } else {
          this.setState({
            msg_up: "¿Desea desactivar la notificación?", check: false, idSelect: id,
            estadoAlerta: "I",
            tipoAlerta: this.state.listaAlertas[i].tipo,
            numeroAlerta: this.state.listaAlertas[i].numero,
            mostrarConfirmar: true
          })
        }
        break;
      }
    }


    if (checked === true) {
      this.setState({ msg_up: "¿Desea activar la notificación?", titleMensaje: "Confirmar Operación" });

    } else {
      this.setState({ msg_up: "¿Desea desactivar la notificación?", titleMensaje: "Confirmar Operación" });
    }
    this.modalCtrlConfirmSwitch.click();
  }

  /**
 * HABILITAR / INHABILITAR ALERTAS TARJETAS
 */

  handleChangeSwitchTarjetas = (checked, event, id) => {
    for (var i = 0; i < this.state.listaAlertasTarjetas.length; i++) {
      if (this.state.listaAlertasTarjetas[i].nroTarjeta === id) {
        if (checked === true) {
          this.setState({
            msg_up: "Desea activar la notificación para la tarjeta seleccionada?", check: true, idSelect: id,
            estadoAlerta: "A",
            marca: this.state.listaAlertasTarjetas[i].marca,
            numeroTarjetaPrincipal: this.state.listaAlertasTarjetas[i].nroTarjeta,

            mostrarConfirmar: true
          });
        } else {
          this.setState({
            msg_up: "Desea desactivar para la tarjeta seleccionada?", check: false, idSelect: id,
            estadoAlerta: "I",
            marca: this.state.listaAlertasTarjetas[i].marca,
            numeroTarjetaPrincipal: this.state.listaAlertasTarjetas[i].nroTarjeta,

            mostrarConfirmar: true
          })
        }
        break;
      }
    }
    /*if (checked === true) {
      this.setState({ msg_up: "Desea activar la notificación?", titleMensaje: "Confirmar Operación" });

    } else {
      this.setState({ msg_up: "Desea desactivar la notificación?", titleMensaje: "Confirmar Operación" });
    }*/
    this.modalCtrlConfirmSwitchTarjetas.click();
  }

  /**
* HABILITAR / INHABILITAR ALERTAS TARJETAS
*/

  handleChangeSwitchTarjetasAdd = (checked, event, id) => {
    for (var i = 0; i < this.state.listaAlertasTarjetas.length; i++) {
      if (this.state.listaAlertasTarjetas[i].nroTarjeta === id) {
        if (checked === true) {
          this.setState({
            msg_up: "Desea activar la notificación para la tarjeta seleccionada?", check: true, idSelect: id,
            estadoAlerta: "A",
            marca: this.state.listaAlertasTarjetas[i].marca,
            numeroTarjetaAdd: this.state.listaAlertasTarjetas[i].nroTarjeta,
            estadoAdicional: "S",
            mostrarConfirmar: true
          });
        } else {
          this.setState({
            msg_up: "Desea desactivar para la tarjeta seleccionada?", check: false, idSelect: id,
            estadoAlerta: "I",
            marca: this.state.listaAlertasTarjetas[i].marca,
            numeroTarjetaAdd: this.state.listaAlertasTarjetas[i].nroTarjeta,
            estadoAdicional: "N",
            mostrarConfirmar: true
          })
        }
        break;
      }
    }
    /*if (checked === true) {
      this.setState({ msg_up: "Desea activar la notificación?", titleMensaje: "Confirmar Operación" });
 
    } else {
      this.setState({ msg_up: "Desea desactivar la notificación?", titleMensaje: "Confirmar Operación" });
    }*/
    this.modalCtrlConfirmSwitchTarjetasAdd.click();
  }

  changeInput(e) {
    this.setState({
      showMe: true,
      inputDisabled: false
    });

    e.preventDefault();

  }
  cargarToggle(e) {

    e.preventDefault();

  }
  onChange = (event) => {
    this.state.telefono(event.target.value);

  }
  onChangeNew = (event) => {
    this.state.telefonoNuevo(event.target.value);
  }
  confirmarBtnAlertas = () => {

    trackPromise(
      SolicitudesService.activarDesactivarAlertas(this.state.tipoAlerta, this.state.numeroAlerta, this.state.check ? "A" : "I")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno == 0) {
            /*this.getListaDebitoAutomatico()
            this.getCuentasSocio();*/
            //this.initState()
            Popup.queue(
              this.notifiPopupCambiarCuenta(
                "Confirmar",
                jsonData.mensajeRetorno,
                // jsonData.datos,
                // this.state.cuentaOrigenSelected
              )
            );
            this.setState({ listaAlertas: this.obtenerListadoAlertas() });
          }
          else {

            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));

  }
  confirmarBtnActualizacionAdicional = () => {

    trackPromise(
      SolicitudesService.actualizarEstadoAdicional(this.state.numeroTarjetaAdd, this.state.estadoAdicional, this.state.check ? "A" : "I")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno == 0) {
            /*this.getListaDebitoAutomatico()
            this.getCuentasSocio();*/
            //this.initState()
            Popup.queue(
              this.notifiPopupCambiarCuenta(
                "Confirmar",
                jsonData.mensajeRetorno,
                // jsonData.datos,
                // this.state.cuentaOrigenSelected
              )
            );
            this.setState({ listaTC: this.obtenerTarjetas() });

          }
          else {

            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));

  }

  notifiPopupCambiarCuenta = (titulo, mensaje, nroOperacion, cuentaSeleccionada) =>

    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],

      },

    });


  agregarAlerta = (e) => {

    if (this.state.alertasDisp.length == 0) {

      this.setState({
        msg_up: "Ya se ha suscripto a todas las alertas anteriormente, favor activar desde el listado",
        titleMensaje: "Info",
        mostrarConfirmar: false
      });

      this.modalCtrlConfirmSwitch.click();
    } else {
      history.push(ConfigService.getPathByName("agregarAlerta")?.url);
      window.location.reload();
    }

  }

  buscarAlerta = (e) => {
    var lista = this.state.listaAlertasOriginal;
    var alertasFiltro = [];
    if (this.state.alertaSelected && this.state.alertaSelected.label) {
      var res_label = this.state.alertaSelected.label.split(" -");

      for (var i = 0; i < lista.length; i++) {
        if (lista[i].descripcion == res_label[0]) {
          alertasFiltro.push(lista[i]);

        }

      }
    }


    if (alertasFiltro.length > 0) {
      this.setState({
        listaAlertas: alertasFiltro
      })
    }
    e.preventDefault();
  }

  /**
     * @description esta variable, guarda las funciones a ejecutar segun sea el path
     */
  funciones = {
    alertas: {
      resumenAlertasActivadas: this.obtenerListadoAlertas,
      resumenAlertasTarjetas: this.obtenerListadoAlertas

    }, prestamos: {
      resumenPrestamosActivos: this.cargarPrestamos,
      resumenPrestamosSolicitudes: this.cargarPrestamosSolicitados
    },

  }
  obtenerTarjetas = () => {

    var respuesta = [];
    trackPromise(
      SolicitudesService.getAlertasTarjetas(this.props.telefono)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.resultadoTarjetas.length; i++) {
              respuesta.push({
                id: i + 1,
                marca: jsonData.resultadoTarjetas[i].marca,
                nroTarjeta: jsonData.resultadoTarjetas[i].nroTarjeta,
                suscribir: false,
                adicional: false,
              });
            }
            this.setState({ listaTC: respuesta });
          }
          else {
            this.setState({ listaTC: [] });
            Popup.queue(this.notifiPopup("Info", "No tiene Tarjetas que mostrar"));
            return;
          }
          this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });

        }

        ));

  }

  funcionNumeroActual = (vNumeroActual) => {
    // this.setState({numeroActual: vNumeroActual})
    this.props.mostrarNumeroActual(this.state.telefonoActual);
  }

  render() {

    return (

      <div className="content-wrapper">


        <ConfirmarOperacionSimple
          idModal="modalCtrlConfirmSwitch"
          title={this.state.titleMensaje}
          mensaje={this.state.msg_up}
          confirmarBtn={this.confirmarBtnAlertas.bind(this)}
          mostrarConfirmar={this.state.mostrarConfirmar}
        />
        <ConfirmarOperacionSimple
          idModal="modalCtrlConfirmSwitchTarjetas"
          title={this.state.titleMensaje}
          mensaje={this.state.msg_up}
          confirmarBtn={this.confirmarBtnTarjetas.bind(this)}
          mostrarConfirmar={this.state.mostrarConfirmar}
        />
        <ConfirmarOperacionSimple
          idModal="modalCtrlConfirmSwitchTarjetasAdd"
          title={this.state.titleMensaje}
          mensaje={this.state.msg_up}
          confirmarBtn={this.confirmarBtnActualizacionAdicional.bind(this)}
          mostrarConfirmar={this.state.mostrarConfirmar}
        />
        <ConfirmarOperacion
          idModal="idModalConfirm"
          title="Suscripción a Alertas"
          items={this.state.itemsConfirm}
          confirmarBtn={this.confirmarBtnNum.bind(this)}
        />


        <Titulo texto="Suscripción a Alertas" />


        <section className="content">
          <form id="idAlertaForm">
            <div className="container">
              <div class="row justify-content-md-center">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio />
                    </div>

                    <div className="card-body" style={{ paddingBottom: "0px" }}>
                    <div className="row">
                    <div className="col-lg-8 col-md-4 col-12">
                    {this.state.showMe && <p className="nro-telefono-contacto" style={{ margin: "0px" }}>
                          Número de Contacto Actual: {this.state.telefonoActual}
                         
                        </p>}
                    </div>
                    <div className="col-lg-2 col-md-4 col-12 btn-consulta">
                    <button className="btn btn-cu-primary float-right" style={{ width:"100%"}} cargarNumeroActual={this.funcionNumeroActual} onClick={this.agregarAlerta}>
                              <FontAwesomeIcon icon={faBell} />  Agregar Alerta
                              </button>
                    </div>
                    <div className="col-lg-2 col-md-4 col-12">
                    <button className="btn btn-cu-secundary float-left" style={{ width:"100%"}} onClick={this.cargarToggle}
                                data-toggle="collapse" data-target="#collapse" aria-expanded={this.state.expandir} aria-controls="collapse">
                              <FontAwesomeIcon icon={faPhone} />  Cambiar Número
                              </button>
                             
                    </div>
                    </div>
                    <div className="row">
                            <div className="col-md-12">
                              <div className="collapse" id="collapse">
                                <div className="card">
                                  <div className="card-body">
                                  <label className="input-label-bold">
                                          Ingrese el nuevo nro. de teléfono celular que recibirá la alerta</label>
                                    <div className="row">
                                      <div className="col-md-6 col-12">
                                     
                                          <CampoNroTelefono phoneSelectorValue={this.phoneSelectorValue.bind(this)} phoneSelector={this.state.phoneFormat} />
                                      </div>
                                      <div className="col-md-6 col-12 btn-guardar" style={{marginTop:"0.5rem"}}>
                                      <button disabled={this.state.disableSave} className="btn btn-cu-primary" style={{width:"100%" }} onClick={() => this.loadDataConfirmActualizarNumero()} ><FontAwesomeIcon style={{margin: "0 0.5rem"}} icon={faPhone}/> Guardar Número</button>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      <div className="col-md-12" style={{ textAlign: "end", padding: "0px" }}>
                        
                      </div>
                      {!this.state.showMe && <div className="col-md-12 float-right">
                        <button className="btn btn-cu-primary float-right" onClick={this.agregarAlerta}>
                          Agregar Alerta
                        </button>
                      </div>}
                    </div>
                    <hr />

                    <div className="container">
                      <div className="row ">
                        <div className="col-md-9">
                          <label className="input-label-bold " style={{ color: "gray" }}> Seleccione la alerta que desea buscar</label>
                         </div>
                          <div className="col-md-9 btn-consulta">
                            <div className="is-invalid" id="prueba">
                              <Select id="tipo" name="tipo"
                                defaultValue={this.state.alerta}
                                onChange={this.handleChangeSelector}
                                instanceId="groupselect"
                                placeholder="-- seleccione --"
                                options={this.state.listaAlertasOriginal}
                                isClearable
                                noOptionsMessage={() => 'SIN DATOS'}
                                ref={c => (this.groupSelect) = c}
                              />

                            </div>

                        </div>

                        <div className="col-md-3 btn-consulta" style={{marginTop:"0"}}>
                          
                            <button className="botonBuscar btn btn-cu-secundary" onClick={this.buscarAlerta}>
                              <FontAwesomeIcon icon={faSearch} />Buscar
                            </button>

                          </div>
                        
                      </div>
                      <div className="col-lg-12">
                        <br />
                        <div className="">

                          <label className="input-label-bold col-md-12">
                            Alertas Suscriptas
                          </label>
                        </div> <br />

                        <div className="card-body pad table-responsive card-body-tab">
                          <div className="card card-tab">
                            <div className="card-header p-2 card-header-tab">
                              <ul className="nav nav-pills">

                                <AuxNavItem
                                  name="resumenPrestamosActivos"
                                  href="#prestamosActivos"

                                >
                                <FontAwesomeIcon icon={faBell} />  Alertas
                                </AuxNavItem>

                                <AuxNavItem
                                  name="resumenPrestamosSolicitudes"
                                  href="#prestamosSolicitados"

                                >
                                 <FontAwesomeIcon icon={faCreditCard} /> Alertas Tarjetas
                                </AuxNavItem>


                              </ul>
                            </div>
                            {/* /.card-header */}
                            <div className="">
                              <div className="tab-content">

                                <TabPane name="resumenPrestamosActivos" id="prestamosActivos">
                                  <div className="card-body">

                                    <div className="row">
                                      <div className="col-md-12">
                                        <DataTable
                                          columns={this.obtenerColumasAlert()}
                                          data={this.obtenerListaAlert()}
                                          noHeader={true}
                                          dense={true}
                                          pagination={true}
                                          paginationComponentOptions={paginationOptions}
                                          striped={true}
                                          noDataComponent="no hay registros para mostrar"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                </TabPane>

                                <TabPane name="resumenPrestamosSolicitudes" id="prestamosSolicitados" >

                                  <div className="row">


                                    <div className="col-md-12 card-body" style={{ marginBottom: "0px" }}>


                                      <div className="table-responsive">
                                        <DataTable
                                          noHeader={true}
                                          columns={this.getColumnTarjeta()}
                                          data={this.state.listaAlertasTarjetas}
                                          dense={true}
                                          striped={true}
                                          responsive={true}
                                          noDataComponent="no hay registros para mostrar" />
                                      </div>
                                    </div>
                                  </div>
                                </TabPane>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <a
          ref={(a) => (this.modalCtrlConfirm = a)}
          href="#"
          hidden
          id="modalCtrlConfirm"
          data-toggle="modal"
          data-target="#idModalConfirm"
        ></a>
        <a
          ref={(a) => (this.modalCtrlConfirmSwitch = a)}
          href="#"
          hidden
          id="modalCtrlConfirmSwitch"
          data-toggle="modal"
          data-target="#modalCtrlConfirmSwitch"
        ></a>
        <a
          ref={(a) => (this.modalCtrlConfirmSwitchTarjetas = a)}
          href="#"
          hidden
          id="modalCtrlConfirmSwitchTarjetas"
          data-toggle="modal"
          data-target="#modalCtrlConfirmSwitchTarjetas"
        ></a>
        <a
          ref={(a) => (this.modalCtrlConfirmSwitchTarjetasAdd = a)}
          href="#"
          hidden
          id="modalCtrlConfirmSwitchTarjetasAdd"
          data-toggle="modal"
          data-target="#modalCtrlConfirmSwitchTarjetasAdd"
        ></a>

      </div>
    );
  }
}
